import { LoaderFunctionArgs } from 'react-router-dom'
import { protectedLoader } from './protectLoader'
import { PORTAL_ADMIN, PORTAL_SUPPORT } from '.'
import { lazyRoute } from '../utils/lazyRoute'

const androidVersionsRoutes = [
  {
    path: '/android-versions',
    lazy: lazyRoute(() => import('../pages/Portal/AndroidVersions')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [PORTAL_ADMIN, PORTAL_SUPPORT],
      }),
  },
]

export default androidVersionsRoutes
